import { ReactComponent as OpenUpdateLogSvg } from './icon/open-update-log.svg';
import './index.less';
import { useEffect, useState } from 'react';
import { Modal, Tooltip } from 'antd';
import ReactMarkdown from 'react-markdown';
import localStore from '@/store/local-store';
import { getValueByKey } from '@/declare/api/dictionary/version';
import React from 'react';
import { Button, notification, Space } from 'antd';
import { Dictionary } from '@/declare/enums/dictionary';
import { useLocation } from 'react-router-dom';
import { isEmployedStatus, UserStatus } from '@/declare/enums/user-status';


interface IBtnProps {
    visible: boolean;
    changeVisible: (value: boolean) => void;
}

export const UserUpdateLogActiveBtn = (props: IBtnProps) => {

    return <div className='user-feedback-active-btn-container' >
        <Tooltip title="更新日志">
            <div className='btn' onClick={() => props.changeVisible(true)}><OpenUpdateLogSvg /></div>
        </Tooltip>
    </div>
}

interface IProps {
    visible: boolean,
    changeVisible: (value: boolean) => void
}

export default function UserUpdateLogPanel(props: IProps) {

    const [markdownContent, setMarkdownContent] = useState<string>('');
    const [api, contextHolder] = notification.useNotification(); // 提示框
    const location = useLocation();


    // 加载markdown日志文件
    useEffect(() => {
        if (props.visible) {
            fetch('/UPDATELOG.md') // public 文件夹下的文件直接通过根路径访问
                .then(res => res.text())
                .then(text => {
                    setMarkdownContent(text);
                    // const version = extractVersionFromMarkdown(text);
                    // if (version) {
                    //     localStore.updateVersionNumber = version;
                    // }
                })
                .catch(error => {
                    console.error('加载更新日志失败:', error);
                    setMarkdownContent('# 更新日志加载失败');
                });
        }
    }, [props.visible])

    // 定时轮询version是否为最新
    useEffect(() => {
        checkVersion();
        const intervalId = setInterval(() => {
            checkVersion();
        }, 120000);
        return () => clearInterval(intervalId);
    }, [])

    const checkVersion = () => {

        getValueByKey(Dictionary.VERSION).then(res => {
            const newVersionNumber = res.data;
            const currentVersion = __APP_VERSION__;
            const shouldOpen = localStorage.getItem('openUpdateLogAfterRefresh');
            if (!!shouldOpen) return;

            if (currentVersion != newVersionNumber && isNewerVersion(currentVersion, newVersionNumber)) {
                // 设置自动弹出日志为true
                localStorage.setItem('openUpdateLogAfterRefresh', 'true');
                // 更新版本号到localstore
                // localStore.versionNumber = newVersionNumber;
                // 唯一key，不会重复弹出弹窗
                const key = `update-notification`;
                const btn = (
                    <Space>
                        <Button type="link" size="small" onClick={() => {
                            localStorage.removeItem('openUpdateLogAfterRefresh');
                            api.destroy(key);
                        }}>
                            关闭
                        </Button>
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                                // 更新版本号到localstore
                                //localStore.updateVersionNumber = newVersionNumber;
                                // 设置自动弹出日志为true
                                //localStorage.setItem('openUpdateLogAfterRefresh', 'true');
                                api.destroy(key);
                                window.location.reload();
                            }}
                        >
                            确认
                        </Button>
                    </Space>
                );

                api.info({
                    message: '发现新版本',
                    description: (
                        <div>
                            <p>检测到新版本：{currentVersion} → {newVersionNumber}</p>
                            <p>点击确认后刷新并查看更新日志</p>
                        </div>
                    ),
                    btn,
                    key,
                    duration: null,
                    onClose: () => {
                        localStorage.removeItem('openUpdateLogAfterRefresh');
                    },
                });
            }
        });
    };

    // 监听 刷新后自动弹出日志
    useEffect(() => {
        const path = location.pathname;
        const userId = localStore.userId;
        const user = localStore.getUser();
        if (path.includes("/recruit") || !userId || (!user?.libAdmin && !isEmployedStatus(user?.userStatus))) {
            props.changeVisible(false);
            return;
        }

        const shouldopen = localStorage.getItem('openUpdateLogAfterRefresh');
        let localVersion = localStore.versionNumber || "0.0.0";
        let currentVersion = __APP_VERSION__;

        if (!!shouldopen || isNewerVersion(localVersion, currentVersion)) {
            props.changeVisible(true);
            localStorage.removeItem('openUpdateLogAfterRefresh');
            localStore.versionNumber = currentVersion;
        }
    }, [location.pathname]);

    function isNewerVersion(oldVer: string, newVer: string): boolean {
        const oldParts = oldVer.split('.').map(Number);
        const newParts = newVer.split('.').map(Number);

        for (let i = 0; i < Math.max(oldParts.length, newParts.length); i++) {
            const oldPart = oldParts[i] || 0;
            const newPart = newParts[i] || 0;
            if (newPart > oldPart) return true;
            if (newPart < oldPart) return false;
        }
        return false;
    }

    return (
        <>
            {contextHolder}
            <Modal
                title='更新日志'
                open={props.visible}
                mask
                wrapClassName='user-updateLog-modal-container'
                width={860}
                footer={null}
                onCancel={() => props.changeVisible(false)}
            >
                <div className='updateLog-box'>
                    <div id="updateLog-list" className='updateLog-list'>
                        <ReactMarkdown>
                            {markdownContent ? markdownContent.replace(/\n/g, '  \n') : ''}
                        </ReactMarkdown>
                    </div>
                </div>
            </Modal>
        </>
    )
}